import AbstractService from './AbstractService';

export default class MedicalLeaveService extends AbstractService {
  url(url) {
    return `/medicalLeave${url}`;
  }

  async createLeave(model) {
    const data = await this.http.post(this.url('/createLeave'), model);
    return data;
  }

  getTo(day) {
    const d = new Date();
    d.setDate(d.getDate() + day);
    return d.valueOf();
  }

  async showLeaves(type) {
    const params = {};
    if (type) {
      params.from = new Date().valueOf();
      params.to = type == 'week' ? this.getTo(7) : this.getTo(0);
    }
    const data = await this.http.get(this.url('/readLeaves'), { params });
    return data;
  }

  async deleteLeave(reference) {
    const params = {
      delete: true,
    };
    const data = await this.http.get(this.url(`/${reference}`), { params });
    return data;
  }

  async updateLevae(reference, body) {
    const data = await this.http.put(this.url(`/update/${reference}`), body);
    return data;
  }
}
